exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirm-add-class .modal-body h4{font-family:brandon-grotesque,Helvetica,Arial,sans-serif;padding:0 0 1em;margin:0}.confirm-add-class .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/dashboard/confirmAddClassModal.scss
// module id = 1293
// module chunks = 2